module.exports = __webpack_public_path__ + "static/media/iconCoursesActive.250a038b.svg";